@if (ready) {
  <form
    class="product-form"
    [formGroup]="productForm"
    [class.product-form--bundle]="isBundle">
    <input type="hidden" formControlName="productId" />
    @if (!isBundle) {
      <app-divider></app-divider>
    }
    <div class="product-form__specs specs" formArrayName="specs">
      @for (
        specControl of specsFormGroupArray.controls;
        track specControl;
        let i = $index
      ) {
        <div class="form-group">
          <div [formGroupName]="i" class="input-group">
            <input type="hidden" formControlName="specId" />
            <label class="input-group__label">
              {{ getControlLabel(specControl.value) }}
            </label>
            <se-fe-form-field-select
              [id]="specControl.value['specId']"
              [seFeDataAriaLabel]="getControlLabel(specControl.value)"
              [seFeDataPlaceholder]="getPlaceholder(specControl.value)"
              class="select-control"
              [ngClass]="{
                'select-control--error': displayControlErrors(specControl),
              }"
              formControlName="optionId"
              [seFeDataOptions]="
                specOptions[specControl.value['specId']]
              "></se-fe-form-field-select>
          </div>
        </div>
      }
    </div>
    @if (showQuantity) {
      <div class="product-form__quantity form-group input-group">
        <label class="input-group__label">Quantity</label>
        <se-fe-form-field-quantity
          formControlName="quantity"
          [seFeDataMin]="1"></se-fe-form-field-quantity>
      </div>
    }
  </form>
} @else {
  <div class="modal-loader">
    <se-fe-spinner
      [seFeDataSize]="800"
      seFeDataAriaLabel="Product loading"></se-fe-spinner>
  </div>
}
